import React from 'react';
import { connect } from 'react-redux';
import { Form, Label, Flex, Pane } from '@leverege/ui-elements';
import { System } from '@leverege/api-redux';
import { withMolten } from '@leverege/molten-core';
import SortFactory from "../../attributes/enum/EnumValueSorterFactory.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_ARR = [];
function FormResourceEnumEditor(props) {
  const {
    attr,
    values,
    valueSortModel
  } = props;
  const hint = attr?.blueprint?.attribute?.getTagStartingWith('hint:', true);
  const getTitle = (cValue, values) => {
    return cValue?.name || hint;
  };
  const sValues = SortFactory.create(valueSortModel, values);
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colS",
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "inputTitle",
      children: attr.displayName
    }), /*#__PURE__*/_jsx(Flex, {
      variant: "rowS",
      align: "center",
      children: /*#__PURE__*/_jsx(Form.Selector, {
        name: attr?.blueprint?.updatePath,
        showFilter: true,
        toggleVariant: "inputSelector|selector",
        nameKey: "name",
        valueKey: "value",
        values: sValues,
        title: getTitle
      })
    }), /*#__PURE__*/_jsx(Form.Error, {
      variant: "inputCaptionSmallError",
      name: attr?.blueprint?.updatePath
    })]
  });
}
const ConnectedResourceEnumEditor = withMolten(connect((state, ownProps) => {
  const {
    attr,
    molten
  } = ownProps;
  const enumType = attr?.blueprint?.attribute?.model?.enumType;
  const enumData = System(molten.getConfig('api/systemId')).resourceEnum(enumType).getResourceEnum(state);
  return {
    values: enumData?.values || EMPTY_ARR,
    valueSortModel: enumData?.metadata?.valueSortModel
  };
})(FormResourceEnumEditor));
const type = 'resourceEnum';
export default {
  editor: ConnectedResourceEnumEditor,
  type
};